import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import { DetectRegion } from "ComponentsUI/Navigation";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";

@withRouter
@inject("ApplicationModel")
@observer
export default class DetectRegionContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    clickAccept() {
        let detectRegionModel = this.props.ApplicationModel.detectRegionModel;
        this.setRegion(detectRegionModel.region);
    }

    componentDidMount() {
        this.props.ApplicationModel.detectRegionModel.goDetect();
    }

    render() {
        let show = true;
        let detectRegionModel = this.props.ApplicationModel.detectRegionModel;
        let text = this.props.ApplicationModel.text;
        let link = generateUrl(Routes.SelectRegion.route, {});
        let linkComponent = <Link to={link}></Link>;
        return (
            detectRegionModel.show && (
                <DetectRegion
                    text={text}
                    name={
                        !!detectRegionModel.region
                            ? detectRegionModel.region.name
                            : null
                    }
                    clickAccept={() => this.clickAccept()}
                    linkComponent={linkComponent}
                />
            )
        );
    }
}
